import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormType } from '@fmnts/api/shared';
import { ApiConfigService } from '@fmnts/api/util';
import { Observable, map } from 'rxjs';
import { ApiNextFormMinimalAdapter } from '../adapter/next-form.adapter';
import { IApiNextFormMinimal } from '../api-model/api-model';
import { NextFormMinimal } from '../model/next-form';

export interface GetNextFormListQuery {
  formType?: FormType;
}

@Injectable({ providedIn: 'root' })
export class FormNextApi {
  private static readonly rootUrl = '/api/next/v1/forms/';

  private adapter = new ApiNextFormMinimalAdapter();

  constructor(
    private http: HttpClient,
    private configService: ApiConfigService,
  ) {}

  list(query: GetNextFormListQuery = {}): Observable<NextFormMinimal[]> {
    const url = query.formType
      ? this.configService.buildApiUrl([FormNextApi.rootUrl, query.formType])
      : this.configService.buildApiUrl([FormNextApi.rootUrl]);

    return this.http
      .get<{ results: IApiNextFormMinimal[] }>(url)
      .pipe(map((obj) => obj.results.map((form) => this.adapter.adapt(form))));
  }
}
